module.exports = "/subscriptions/assets/9712523424319c55aee4a3b7fd567df3.png";